export default "__VITE_ASSET__C1EaOP9d__"